import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { musician } from '@/mocks/musician';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Media', path: '/music' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Experience', path: '/experience' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';
  const transparent = isHome && !isScrolled;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        transparent
          ? 'bg-transparent'
          : 'bg-background-50 shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-3 group cursor-pointer whitespace-nowrap">
            <div className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center overflow-hidden flex-shrink-0 transition-colors duration-500 ${
              transparent ? 'bg-white/20 backdrop-blur-sm' : 'bg-background-200'
            }`}>
              <img
                src={musician.logoUrl}
                alt="Jackson Lacefield Logo"
                className="w-8 h-8 md:w-9 md:h-9 object-contain"
              />
            </div>
            <span className={`font-heading text-lg md:text-xl font-semibold tracking-tight transition-colors duration-500 ${
              transparent ? 'text-white' : 'text-foreground-900'
            }`}>
              Jackson Lacefield
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-label text-sm tracking-wide transition-colors duration-500 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? transparent ? 'text-white underline underline-offset-4' : 'text-accent-500'
                    : transparent ? 'text-white/80 hover:text-white' : 'text-foreground-700 hover:text-foreground-900'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors duration-500 ${
              transparent ? 'text-white' : 'text-foreground-700'
            }`}
            aria-label="Toggle navigation menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className={`md:hidden pb-5 flex flex-col gap-4 rounded-b-xl px-4 -mx-2 mt-2 ${
            transparent ? 'bg-foreground-950/80 backdrop-blur-md' : 'bg-background-50 shadow-lg'
          }`}>
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`font-label text-base transition-colors cursor-pointer py-1 ${
                  location.pathname === link.path
                    ? 'text-accent-500'
                    : transparent ? 'text-white/80 hover:text-white' : 'text-foreground-700 hover:text-foreground-900'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}